var icon_button_default = {
  "audioIconButton": "_1oCZx"
};
export {
  icon_button_default as default
};
//# sourceMappingURL=icon-button-scss.js.map
